/*
 * Fragment diamond — the universal purple faceted FRG icon used
 * exclusively inside the onboarding tutorial (Feb 2026).
 *
 * The diamond shape mirrors the previews: a purple, faceted rhombus
 * with a slight inner highlight. Kept as a single SVG so it scales
 * cleanly at every size the scenes use (14 px in inline balances up
 * to 80 px in the wheel/predict spotlight). Uses `currentColor`-free
 * fills so callers can restyle via CSS variables when needed.
 */
export function FragmentDiamond({ size = 24, className, style, ...rest }) {
  const s = typeof size === "number" ? `${size}px` : size;
  return (
    <svg
      viewBox="0 0 32 44"
      width={s}
      height={s}
      className={`hbo-frg-diamond ${className || ""}`}
      style={style}
      aria-hidden="true"
      {...rest}
    >
      <defs>
        <linearGradient id="hbo-frg-face-left" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%"  stopColor="#a78bfa" />
          <stop offset="100%" stopColor="#6d28d9" />
        </linearGradient>
        <linearGradient id="hbo-frg-face-right" x1="1" y1="0" x2="0" y2="1">
          <stop offset="0%"  stopColor="#c4b5fd" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>
        <linearGradient id="hbo-frg-face-shine" x1="0.5" y1="0" x2="0.5" y2="1">
          <stop offset="0%"  stopColor="#ffffff" stopOpacity="0.65" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
      </defs>
      {/* left face */}
      <polygon points="16,2 3,14 16,22" fill="url(#hbo-frg-face-left)" />
      {/* right face */}
      <polygon points="16,2 29,14 16,22" fill="url(#hbo-frg-face-right)" />
      {/* lower-left face */}
      <polygon points="3,14 16,22 16,42" fill="#5b21b6" />
      {/* lower-right face */}
      <polygon points="29,14 16,22 16,42" fill="#4c1d95" />
      {/* central shine */}
      <polygon points="16,2 12,14 16,22 20,14" fill="url(#hbo-frg-face-shine)" opacity="0.9" />
    </svg>
  );
}
